import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useNotifications } from '@/hooks/useNotifications';
import { NotificationPanel } from '@/components/NotificationPanel';

export const Header = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications(user?.uid || '');

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <>
    <header className="flex items-center p-4 bg-white border-b sticky top-0 z-20 h-20">
      <div className="flex-1">
        <button 
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          className="md:hidden text-gray-500 hover:text-gray-600"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <div className="flex-1 flex justify-center">
        <div className="hidden md:flex">
          <img src="/images/sidepocket_Logo.png" alt="Sidepocket Logo" className="h-10" />
        </div>
      </div>

      <div className="flex-1 flex justify-end items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-gray-700 hidden sm:inline">{user?.displayName || 'Guest'}</span>
          <Link to="/profile">
            <img
              className="h-10 w-10 rounded-full object-cover"
              src={user?.photoURL || '/images/sidepocket_symbol.png'}
              alt="User icon"
            />
          </Link>
        </div>

        <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative text-gray-500 hover:text-gray-600"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
            </svg>
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 flex items-center justify-center h-5 w-5 text-xs text-white bg-red-500 rounded-full">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>

          {showNotifications && (
            <NotificationPanel
              notifications={notifications}
              onClose={() => setShowNotifications(false)}
              onMarkAsRead={markAsRead}
              onMarkAllAsRead={markAllAsRead}
            />
          )}
        </div>

        <button onClick={handleSignOut} className="text-sm text-gray-600 hover:text-gray-800">
          ログアウト
        </button>
      </div>
    </header>

    {/* モバイルメニュー */}
    {showMobileMenu && (
      <div className="md:hidden fixed inset-0 z-50 bg-black bg-opacity-50" onClick={() => setShowMobileMenu(false)}>
        <div className="bg-white w-64 h-full shadow-xl" onClick={(e) => e.stopPropagation()}>
          <div className="p-4 border-b flex items-center justify-between">
            <img src="/images/sidepocket_Logo.png" alt="Sidepocket" className="h-8" />
            <button onClick={() => setShowMobileMenu(false)} className="text-gray-500">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <nav className="p-4 space-y-2">
            <Link
              to="/"
              onClick={() => setShowMobileMenu(false)}
              className="block px-4 py-3 rounded-lg hover:bg-gray-100 text-gray-700"
            >
              ホーム
            </Link>
            <Link
              to="/calendar"
              onClick={() => setShowMobileMenu(false)}
              className="block px-4 py-3 rounded-lg hover:bg-gray-100 text-gray-700"
            >
              カレンダー
            </Link>
            <Link
              to="/projects"
              onClick={() => setShowMobileMenu(false)}
              className="block px-4 py-3 rounded-lg hover:bg-gray-100 text-gray-700"
            >
              プロジェクト
            </Link>
            <Link
              to="/clients"
              onClick={() => setShowMobileMenu(false)}
              className="block px-4 py-3 rounded-lg hover:bg-gray-100 text-gray-700"
            >
              クライアント
            </Link>
            <Link
              to="/summary"
              onClick={() => setShowMobileMenu(false)}
              className="block px-4 py-3 rounded-lg hover:bg-gray-100 text-gray-700"
            >
              サマリー
            </Link>
            <Link
              to="/profile"
              onClick={() => setShowMobileMenu(false)}
              className="block px-4 py-3 rounded-lg hover:bg-gray-100 text-gray-700"
            >
              プロフィール
            </Link>
          </nav>
        </div>
      </div>
    )}
    </>
  );
};
